'use strict';


var platformEvent = null;


if ( PLATFORM === 'MAG' || NANOCORE ) {
    platformEvent = require('../platforms/mag/event');
}
if ( PLATFORM === 'SMARTTV' ) {
    platformEvent = require('../platforms/smarttv/event');
}
if ( PLATFORM === 'TIZEN' ) {
    platformEvent = require('../platforms/tizen/event');
}

if ( PLATFORM !== 'MAG' && PLATFORM !== 'TIZEN' && PLATFORM !== 'SMARTTV' && !NANOCORE ) {
    platformEvent = require('../platforms/browser/event');
}

module.exports = platformEvent;
